export { RoomRateConfigurationWizardConnected as RoomRateConfigurationWizard } from './container';
